export default __webpack_public_path__ + "6fb4917b4ad13067f8fd20b2cea2728a.png";